import * as React from "react";
import ViewList from "@warda/library-ui/layout/ViewList";
import { FileType } from "@warda/library-ui/interfaces";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import Btn from "@warda/library-ui/core/Btn";
import ViewListAssetMedia from "./ViewListAssetMedia";
import ViewListAssetFolder from "./ViewListAssetFolder";
import { itemsTypeSort, needFooter, needHeader } from "../utils";
import ViewListHeader from "./ViewListHeader";
import ViewListFooter from "./ViewListFooter";
import { ATTRIBUTES } from "../../constants";
const itemHeight = () => 50;
const ViewListAssetUnknown = ({ id, color }) => {
    return React.createElement(Btn, { color: color, label: String(id) });
};
const View = ({ color, searchTime, files, filesTotal, filesSlcId, loading, onClick, sortKey, sortOrd, placeholderIcon, placeholderLabel, moreLoading, moreFailed, }) => {
    const itemRender = React.useCallback((p) => {
        switch (p.type) {
            case FileType.FOLDER:
                return React.createElement(ViewListAssetFolder, { ...p, loading: loading });
            case FileType.MEDIA:
                return React.createElement(ViewListAssetMedia, { ...p, loading: loading });
            default:
                return React.createElement(ViewListAssetUnknown, { ...p });
        }
    }, [loading]);
    const itemHeader = React.useCallback(({ type }) => (React.createElement(ViewListHeader, { type: type, filesTotal: filesTotal })), [filesTotal]);
    const itemFooter = React.useCallback(({ type, indexRow }) => (React.createElement(ViewListFooter, { type: type, files: files, filesTotal: filesTotal, indexRow: indexRow, moreLoading: moreLoading, moreFailed: moreFailed })), [files, filesTotal, moreLoading, moreFailed]);
    return (React.createElement(ViewList, { color: color, itemHeight: itemHeight, itemRender: itemRender, itemHeader: itemHeader, itemFooter: itemFooter, needHeader: needHeader, needFooter: needFooter(files, filesTotal), needToolbar: false, items: files, itemsSelectedId: filesSlcId, itemsTypeSort: itemsTypeSort, loading: loading, onClick: onClick, placeholderIcon: placeholderIcon, placeholderLabel: placeholderLabel, columns: isMobile() ? undefined : ATTRIBUTES, columnsSortId: sortKey, columnsSortOrder: sortOrd, resetScrollbar: searchTime }));
};
export default View;
